module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Acknowledgments")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Many people helped with the research for this project, which began in 1990. I would like to thank the staffs at the Henry County Library, Henry County Historical Society, and Indiana Basketball Hall of Fame, New Castle; Western Michigan University Library and staff, especially Natasha Alexander; Kalamazoo College; Sam Hyde of Hyde Brothers Books in Ft. Wayne, Indiana; and Dr. Barbara Allen for her patience in showing me how oral history ought to be done.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many others contributed directly to my understanding of the war and its impact on the people who knew it, including")]), _vm._v(" "), _c('p', {
    staticClass: "poemt"
  }, [_vm._v("Harry Ridout")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Fred and Charlotte Walker")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Judy Capshaw VanMatre")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Sarah Wright Madison")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Charlie and Barbara Bunch Purvis")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Phil and Martha Perry")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Vernie Griffin")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("George and Esta Belle Woods")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Chet and Mary Curry, who read the manuscript and made many valuable suggestions")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Natasha A. Smith, who read the manuscript many times and provided expert proofreading")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Cora Pope, who shared Keith’s story and memory")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Carolyn Nycum, a gal in wartime Kalamazoo, and Jim Nycum, B-17 waist gunner")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Walter Dugan")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Mabel Frogge Smith")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Florence Smith Swann")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Paul Borgman of the 448th AAA")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Maj. Patrick Dugan, for information on the 448th AAA")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Drs. Brad and Dedra Birzer, who never failed to encourage me")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Dr. Kevin Smant, who read parts of the manuscript")])]), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("Stewart and Connie Smith")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Homer and Edith Smith")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Betty Reece Smith")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Jim and Karin Smith")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Ethel Baltimore Moles")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Julie Thompson Calhoun")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("William F. Dillon, 467th and 492nd Bomb Groups")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Russell K. Bond, 467th and 492nd Bomb Groups")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Maxine Moles Thompson")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Marie Moles Hammond")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Wanda Moles Grubbs")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Gemma Moles Smith")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Harold Rothrock")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Jim and Delores Irwin")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Barney Pfenninger")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Jim and Sarah Bates")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("There are many no longer with us who contributed to this book over the years with memories they willingly shared, and with their love, including Edward M. Smith, Fred and Lillian Smith, Jess Moles, Fred Walker, Clay Grubbs, Phil Smith, and Orville Hammond.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If only I had known to ask all the unanticipated questions when they were still with us, this would have been a far better book, and more of their world would have been preserved to instruct those of us who came later.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12b72ff5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Acknowledgments.vue
// module id = 75
// module chunks = 0